import React from 'react';
import { Sidebar } from './Sidebar';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex h-screen bg-slate-50 overflow-hidden font-sans" data-id="element-210" data-mp="l27z02hmres5">
      <Sidebar data-id="element-211" data-mp="zw2ywizt5tr7" />
      <main className="flex-1 overflow-y-auto focus:outline-none relative" data-id="element-212" data-mp="zwmis590qs7v">
        {/* Decorative background element - Orange pittogramma */}
        <div className="absolute top-0 right-0 w-64 h-64 pointer-events-none opacity-5" data-id="element-213" data-mp="7876vrl6oq0r">
          <img src="https://cdn.magicpatterns.com/uploads/fM9z3qaiY6WQJbqFyvrZep/icona_arancione.svg" alt="" className="w-full h-full object-contain" aria-hidden="true" data-id="element-214" data-mp="29vwnfqz8di0" />
        </div>

        <div className="py-8 relative z-10 pb-16" data-id="element-215" data-mp="c71q2un2cgle">
          <div className="max-w-[1600px] mx-auto px-6 lg:px-10" data-id="element-216" data-mp="3knda8r6dz8ke">{children}</div>
        </div>
      </main>
    </div>;
}